export default __webpack_public_path__ + "static/Lsa_banner_mobile-9f07c50e4b33b51b58dcbbd29d04e7c6.jpg";